import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92'),
	() => import('./nodes/93'),
	() => import('./nodes/94'),
	() => import('./nodes/95'),
	() => import('./nodes/96'),
	() => import('./nodes/97'),
	() => import('./nodes/98'),
	() => import('./nodes/99'),
	() => import('./nodes/100'),
	() => import('./nodes/101'),
	() => import('./nodes/102'),
	() => import('./nodes/103'),
	() => import('./nodes/104'),
	() => import('./nodes/105'),
	() => import('./nodes/106'),
	() => import('./nodes/107'),
	() => import('./nodes/108'),
	() => import('./nodes/109'),
	() => import('./nodes/110'),
	() => import('./nodes/111'),
	() => import('./nodes/112'),
	() => import('./nodes/113'),
	() => import('./nodes/114'),
	() => import('./nodes/115'),
	() => import('./nodes/116'),
	() => import('./nodes/117'),
	() => import('./nodes/118'),
	() => import('./nodes/119'),
	() => import('./nodes/120'),
	() => import('./nodes/121'),
	() => import('./nodes/122'),
	() => import('./nodes/123'),
	() => import('./nodes/124'),
	() => import('./nodes/125'),
	() => import('./nodes/126'),
	() => import('./nodes/127'),
	() => import('./nodes/128'),
	() => import('./nodes/129'),
	() => import('./nodes/130'),
	() => import('./nodes/131'),
	() => import('./nodes/132'),
	() => import('./nodes/133'),
	() => import('./nodes/134'),
	() => import('./nodes/135'),
	() => import('./nodes/136'),
	() => import('./nodes/137'),
	() => import('./nodes/138'),
	() => import('./nodes/139'),
	() => import('./nodes/140'),
	() => import('./nodes/141'),
	() => import('./nodes/142'),
	() => import('./nodes/143'),
	() => import('./nodes/144'),
	() => import('./nodes/145'),
	() => import('./nodes/146'),
	() => import('./nodes/147'),
	() => import('./nodes/148'),
	() => import('./nodes/149'),
	() => import('./nodes/150'),
	() => import('./nodes/151'),
	() => import('./nodes/152'),
	() => import('./nodes/153'),
	() => import('./nodes/154'),
	() => import('./nodes/155'),
	() => import('./nodes/156'),
	() => import('./nodes/157'),
	() => import('./nodes/158'),
	() => import('./nodes/159'),
	() => import('./nodes/160'),
	() => import('./nodes/161'),
	() => import('./nodes/162'),
	() => import('./nodes/163'),
	() => import('./nodes/164'),
	() => import('./nodes/165'),
	() => import('./nodes/166'),
	() => import('./nodes/167'),
	() => import('./nodes/168'),
	() => import('./nodes/169'),
	() => import('./nodes/170'),
	() => import('./nodes/171'),
	() => import('./nodes/172'),
	() => import('./nodes/173'),
	() => import('./nodes/174'),
	() => import('./nodes/175'),
	() => import('./nodes/176'),
	() => import('./nodes/177'),
	() => import('./nodes/178'),
	() => import('./nodes/179'),
	() => import('./nodes/180'),
	() => import('./nodes/181'),
	() => import('./nodes/182'),
	() => import('./nodes/183'),
	() => import('./nodes/184'),
	() => import('./nodes/185'),
	() => import('./nodes/186'),
	() => import('./nodes/187'),
	() => import('./nodes/188'),
	() => import('./nodes/189'),
	() => import('./nodes/190'),
	() => import('./nodes/191'),
	() => import('./nodes/192'),
	() => import('./nodes/193'),
	() => import('./nodes/194'),
	() => import('./nodes/195'),
	() => import('./nodes/196'),
	() => import('./nodes/197'),
	() => import('./nodes/198'),
	() => import('./nodes/199'),
	() => import('./nodes/200'),
	() => import('./nodes/201'),
	() => import('./nodes/202'),
	() => import('./nodes/203'),
	() => import('./nodes/204'),
	() => import('./nodes/205'),
	() => import('./nodes/206'),
	() => import('./nodes/207'),
	() => import('./nodes/208'),
	() => import('./nodes/209'),
	() => import('./nodes/210'),
	() => import('./nodes/211'),
	() => import('./nodes/212'),
	() => import('./nodes/213'),
	() => import('./nodes/214'),
	() => import('./nodes/215'),
	() => import('./nodes/216'),
	() => import('./nodes/217'),
	() => import('./nodes/218'),
	() => import('./nodes/219'),
	() => import('./nodes/220'),
	() => import('./nodes/221'),
	() => import('./nodes/222'),
	() => import('./nodes/223'),
	() => import('./nodes/224'),
	() => import('./nodes/225'),
	() => import('./nodes/226'),
	() => import('./nodes/227'),
	() => import('./nodes/228'),
	() => import('./nodes/229'),
	() => import('./nodes/230'),
	() => import('./nodes/231'),
	() => import('./nodes/232'),
	() => import('./nodes/233'),
	() => import('./nodes/234'),
	() => import('./nodes/235'),
	() => import('./nodes/236')
];

export const server_loads = [0,3,4,10,11,12,13,46,18,20,21,22,23,24,25,26,27,28,29,30,31,32,33,35,36,37,38,16,15,40,50];

export const dictionary = {
		"/": [~51],
		"/500": [~177],
		"/angel-policy": [178],
		"/claim": [~179],
		"/(community-indexes)/community": [~52,[2]],
		"/(community-indexes)/community/galleries": [~53,[2]],
		"/(community-indexes)/community/process-videos": [~54,[2]],
		"/(community-pages)/community/[handle]": [~55,[3]],
		"/(community-pages)/community/[handle]/bonus": [~57,[3]],
		"/(community-pages)/community/[handle]/bonus/[id]": [~58,[3]],
		"/(community-pages)/community/[handle]/galleries": [~59,[3]],
		"/(community-pages)/community/[handle]/galleries/[uuid]": [60,[3,4]],
		"/(community-pages)/community/[handle]/galleries/[uuid]/[id]": [~61,[3,4]],
		"/(community-pages)/community/[handle]/galleries/[uuid]/[id]/[any]": [~62,[3,4]],
		"/(community-pages)/community/[handle]/process-videos": [~63,[3]],
		"/(community-pages)/community/[handle]/[id]": [~56,[3]],
		"/contact": [180],
		"/creative-companion": [181],
		"/ellen": [182],
		"/(dialog)/email-list": [64,[5]],
		"/(dialog)/email-list/error": [65,[5]],
		"/(dialog)/email-list/success": [66,[5]],
		"/email": [~183,[41]],
		"/(episode-index)/episodes": [~70,[6],[7]],
		"/(episodes)/episodes/episode-[number=integer]": [76,[9,10]],
		"/(episodes)/episodes/episode-[number=integer]/achievements": [77,[9,10,11]],
		"/(episodes)/episodes/episode-[number=integer]/achievements/[id]": [~78,[9,10,11]],
		"/(episodes)/episodes/episode-[number=integer]/bonus": [79,[9,10,12]],
		"/(episodes)/episodes/episode-[number=integer]/bonus/[id]": [~80,[9,10,12]],
		"/(episodes)/episodes/episode-[number=integer]/gallery": [81,[9,10,13]],
		"/(episodes)/episodes/episode-[number=integer]/gallery/[id]": [~82,[9,10,13]],
		"/(episodes)/episodes/episode-[number=integer]/guests": [~83,[9,10]],
		"/(episodes)/episodes/episode-[number=integer]/in-revue": [~84,[9,10]],
		"/(episodes)/episodes/episode-[number=integer]/process-videos": [~85,[9,10]],
		"/(episode-index)/episodes/schedule": [71,[6],[7]],
		"/(episode-index)/episodes/upcoming": [~72,[6],[7]],
		"/(episode-index)/events": [~73,[8]],
		"/(episode-index)/events/verify_[uuid]": [~75,[8]],
		"/(episode-index)/events/[slug]": [~74,[8]],
		"/extras": [~184],
		"/extras/[path]": [~185],
		"/galleries": [~186],
		"/galleries/[a]": [~187],
		"/galleries/[a]/[b]": [~188],
		"/galleries/[a]/[b]/[c]": [~189],
		"/guest-application": [190],
		"/guests": [~191,[42]],
		"/guests/[slug]": [~192,[42]],
		"/(image-download)/image-downloader/[id]_[password]": [~86],
		"/in-revue": [193,[43]],
		"/login": [~194,[44]],
		"/login/cookie-clear": [~195,[44]],
		"/login/login/register": [~196,[44]],
		"/login/migrate": [~197,[44,45]],
		"/login/migrate/already-migrated": [~198,[44,45]],
		"/login/migrate/cancel": [~199,[44,45]],
		"/login/migrate/setup": [200,[44,45,46]],
		"/login/migrate/setup/new_password": [201,[44,45,46]],
		"/login/migrate/setup/subscription": [~202,[44,45,46]],
		"/login/register": [~203,[44]],
		"/login/register/[uuid]": [~204,[44]],
		"/login/reset": [~205,[44]],
		"/login/reset/thanks": [207,[44]],
		"/login/reset/[uuid]": [~206,[44]],
		"/login/security": [~208,[44]],
		"/logout": [~209],
		"/logout/[catch_all]": [~210],
		"/(user)/members": [~88,[14]],
		"/(user)/members/admin": [~100,[14,18]],
		"/(user)/members/admin/map": [~101,[14,18]],
		"/(user)/members/admin/messages": [~102,[14,18,19]],
		"/(user)/members/admin/messages/[user]": [~103,[14,18,19]],
		"/(user)/members/admin/print": [~104,[14,18]],
		"/(user)/members/admin/stats": [~105,[14,18]],
		"/(user)/members/admin/time": [106,[14,18]],
		"/(user)/members/admin/upload": [107,[14,18]],
		"/(user)/members/challenge": [~108,[14,20]],
		"/(user)/members/challenge/past": [~109,[14,20]],
		"/(user)/members/challenge/recent": [~110,[14,20]],
		"/(user)/members/challenge/top-ten": [~111,[14,20]],
		"/(user)/members/contributions": [~112,[14,21]],
		"/(user)/members/contributions/claim": [~114,[14,21]],
		"/(user)/members/contributions/submit": [~115,[14,21]],
		"/(user)/members/contributions/submit/bonus": [~116,[14,21]],
		"/(user)/members/contributions/submit/current": [~117,[14,21,22]],
		"/(user)/members/contributions/submit/current/[UUID=uuid]": [~118,[14,21,22]],
		"/(user)/members/contributions/submit/current/[UUID=uuid]/complete": [~119,[14,21,22]],
		"/(user)/members/contributions/submit/current/[UUID=uuid]/details": [~120,[14,21,22]],
		"/(user)/members/contributions/submit/current/[UUID=uuid]/images": [~121,[14,21,22]],
		"/(user)/members/contributions/submit/current/[UUID=uuid]/review": [~122,[14,21,22]],
		"/(user)/members/contributions/[image]": [~113,[14,21]],
		"/(user)/members/discussions": [~123,[14,23]],
		"/(user)/members/discussions/my-comments": [~124,[14,23]],
		"/(user)/members/discussions/update-discussions": [~125,[14,23]],
		"/(user)/members/downloads": [~126,[14,24]],
		"/(user)/members/downloads/cards": [~127,[14,24]],
		"/(user)/members/downloads/sheets": [~128,[14,24]],
		"/(user)/members/downloads/stamps": [~129,[14,24]],
		"/(user)/members/exchange": [~130,[14,25]],
		"/(user)/members/exchange/birthdays": [~131,[14,25]],
		"/(user)/members/exchange/commitments": [~132,[14,25]],
		"/(user)/members/exchange/help": [133,[14,25]],
		"/(user)/members/exchange/settings": [134,[14,25]],
		"/(user)/members/explorer": [~135,[14,26]],
		"/(user)/members/galleries": [~136,[14,27]],
		"/(user)/members/galleries/create": [138,[14,27]],
		"/(user)/members/galleries/[uuid]": [~137,[14,27]],
		"/(user)/members/guest-crafter": [~139,[14,28]],
		"/(user)/members/guest-crafter/image": [140,[14,28]],
		"/(user)/members/guest-crafter/profile": [~141,[14,28]],
		"/(user)/members/guest-crafter/schedule": [142,[14,28]],
		"/(user)/members/help": [~143,[14,29]],
		"/(user)/members/help/faq": [145,[14,29]],
		"/(user)/members/help/[slug]": [~144,[14,29]],
		"/(user)/members/inbox": [~146,[14]],
		"/(user)/members/media-packs": [147,[14,30]],
		"/(user)/members/media-packs/[episode_number]": [~148,[14,30]],
		"/(user)/members/notifications": [~149,[14,31]],
		"/(user)/members/notifications/all": [~150,[14,31]],
		"/(user)/members/parameters": [151,[14,32]],
		"/(user)/members/parameters/colors": [152,[14,32]],
		"/(user)/members/parameters/elements": [153,[14,32]],
		"/(user)/members/parameters/random": [154,[14,32]],
		"/(user)/members/process-videos": [~155,[14,33]],
		"/(user)/members/process-videos/submit": [~156,[14,33]],
		"/(user)/members/profile": [~157,[14,34]],
		"/(user)/members/profile/image": [~158,[14,34]],
		"/(user)/members/profile/pin": [~159,[14,34]],
		"/(user)/members/scrapbooking": [160,[14,35]],
		"/(user)/members/scrapbooking/life-saver": [~161,[14,35]],
		"/(user)/members/settings": [~162,[14]],
		"/(user)/members/settings/[uuid]": [~163,[14]],
		"/(user)/members/spin-it-forward": [~164,[14,36]],
		"/(user)/members/spin-it-forward/image": [~165,[14,36]],
		"/(user)/members/spin-it-forward/pin": [~166,[14,36]],
		"/(user)/members/spin-it-forward/rules": [167,[14,36]],
		"/(user)/members/spin-sponsor": [~168,[14,37]],
		"/(user)/members/subscription": [169,[14,38]],
		"/(user)/members/subscription/features": [170,[14,38]],
		"/(user)/members/subscription/history": [~171,[14,38]],
		"/(user)/members/subscription/portal": [~172,[14,38]],
		"/(user)/members/subscription/success": [~173,[14,38]],
		"/(user)/members/(surveys-index)/surveys": [~92,[14,16]],
		"/(user)/members/(surveys-index)/surveys/archive": [~93,[14,16]],
		"/(user)/members/(surveys)/surveys/debrief": [~89,[14,15]],
		"/(user)/members/(surveys)/surveys/questions": [~90,[14,15]],
		"/(user)/members/(surveys)/surveys/vetos-[uuid]": [~91,[14,15]],
		"/(user)/members/updates": [~174,[14,39]],
		"/(user)/members/updates/[slug]": [~175,[14,39]],
		"/(user)/members/(video-index)/videos": [~94,[14,17]],
		"/(user)/members/(video-index)/videos/laboratory": [~95,[14,17]],
		"/(user)/members/(video-index)/videos/scrapbooking": [~96,[14,17]],
		"/(user)/members/(video-index)/videos/search": [~97,[14,17]],
		"/(user)/members/(video-index)/videos/show": [~98,[14,17]],
		"/(user)/members/(videos)/videos/[uuid]": [~99,[14]],
		"/(user)/members/zoom": [~176,[14,40]],
		"/privacy-policy": [211],
		"/process-videos": [~212],
		"/shop": [~213,[47]],
		"/shop/merch": [~214,[47]],
		"/shop/trinity": [~215,[47]],
		"/show": [216,[48]],
		"/show/glossary": [217,[48]],
		"/show/parameters": [~218,[48]],
		"/show/participate": [219,[48]],
		"/(spin-it-forward)/spin-it-forward": [~87],
		"/sponsors": [~220,[49]],
		"/submit-video": [233],
		"/submit": [221,[50]],
		"/submit/error": [229,[50]],
		"/submit/late": [230,[50]],
		"/(dialog)/submit/special_guest": [67,[5]],
		"/submit/thanks": [~231,[50]],
		"/submit/vetting": [232,[50]],
		"/submit/[UUID=uuid]": [~222,[50]],
		"/submit/[UUID=uuid]/step-1": [~223,[50]],
		"/submit/[UUID=uuid]/step-2": [~224,[50]],
		"/submit/[UUID=uuid]/step-3": [~225,[50]],
		"/submit/[UUID=uuid]/step-4": [~226,[50]],
		"/submit/[UUID=uuid]/step-5": [~227,[50]],
		"/submit/[UUID=uuid]/support": [~228,[50]],
		"/support": [~234],
		"/swap_[uuid]": [~235],
		"/terms-and-conditions": [236],
		"/(dialog)/utilities/process/deleted": [68,[5]],
		"/(dialog)/utilities/process/published": [69,[5]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';